import { siteSelectionRowFieldConfig } from '../../person/fields/utils/personFieldsUtils';
import { Locale } from '../../../../localization/LocalizationKeys';
import { SiteSelectionRowCriteriaOrder } from '../../../../gql/typings';

export const siteSelectionRowRowIdFieldConfig = siteSelectionRowFieldConfig(
  'rowId',
  ['selectionRow.id'],
  ({ localization }) => ({
    title: localization.formatMessage(Locale.Attribute.Rule_ID),
    sorting: {
      ascend: SiteSelectionRowCriteriaOrder.ROW_ID_ASC,
      descend: SiteSelectionRowCriteriaOrder.ROW_ID_DESC,
    },
    render: record => record.selectionRow?.id ?? localization.formatMessage(Locale.General.Unknown),
  }),
);
